/**
 * @description Main App discount evaluate client (LYN-250).
 * Same DiscountService.evaluate contract as Wave 1 — do not fork.
 *
 * @dependencies apiClient
 * @notes POST /api/discounts/evaluate requires discounts.view.
 * Typed-code misses stay HTTP 200 + codeError.
 */

import apiClient from './apiClient';

const discountService = {
  /**
   * Evaluate discounts for a cart/document/plan.
   * @param {object} input
   * @param {string} input.context
   * @param {boolean} [input.isRecurring]
   * @param {Array<object>} [input.items]
   * @param {number} [input.subtotalCents]
   * @param {string} [input.code]
   * @returns {Promise<{appliedDiscounts: Array, discountTotalCents: number, totalCents: number, codeError: string|null}>}
   */
  evaluate: async (input) => {
    const response = await apiClient.post('/discounts/evaluate', input);
    return response.data;
  }
};

export default discountService;
